import { defaultRenderConfig } from "./result/table/generateResultCells";
import { StandardSearchResultsTable } from "./result/table/StandardSearchResultsTable";
import { mapSearchCriteria, SearchType } from "./searchCriteriaMapper";
import { columnsType, resultRenderConfigType, resultsDisplayType } from "../common/types/search/results";
import { ValidationRule } from "./criteria/validation/validationRule";
import React from "react";
import { searchDefinition } from "../common/types/search/search";

interface defaultSearchDefinitionParams {
	columns?: columnsType;
	criteriaValidation?: { [key: string]: ValidationRule };
	groupRequiredRoles?: () => unknown;
	groupVisibilitySelector?: () => unknown;
	mapSearchCriterion?: () => unknown;
	resultRenderConfig?: (columns: columnsType) => resultRenderConfigType;
	resultsDisplay?: ({
		resultRenderConfig,
		footnotes,
		forPrint,
		paging,
	}: resultsDisplayType) => React.ReactNode | null;
	searchCriteria?: { [key: string]: unknown };
	shouldFetchQuickSearchCriteria?: boolean;
	quickSearchFallbackCriteria?: string[];
	quickSearchCriteriaOrder?: { [key: string]: number };
}

export function createDefaultSearchDefinition({
	columns,
	criteriaValidation = {},
	groupRequiredRoles = () => {},
	groupVisibilitySelector = () => {},
	mapSearchCriterion = () => {},
	resultRenderConfig = defaultRenderConfig,
	resultsDisplay = StandardSearchResultsTable,
	searchCriteria = {},
	shouldFetchQuickSearchCriteria = true,
	quickSearchFallbackCriteria = [],
	quickSearchCriteriaOrder,
}: defaultSearchDefinitionParams): searchDefinition {
	return {
		adCode: undefined,
		additionalAction: undefined,
		additionalLink: undefined,
		additionalSearch: undefined,
		additionalSearchLink: undefined,
		advancedSearchAdditionalLink: undefined,
		actionsButtonDependsOn: undefined,
		contentCredits: undefined,
		criteria: {
			criteria: mapSearchCriteria(
				searchCriteria,
				SearchType.FULL_SEARCH,
				mapSearchCriterion,
				criteriaValidation,
				groupVisibilitySelector,
				groupRequiredRoles,
			),
			quickSearchFallbackCriteria,
			mapSearchCriterion,
			shouldFetchQuickSearchCriteria,
			quickSearchCriteriaOrder,
		},
		customizeQuickSearch: {
			enabled: true,
			radios: undefined,
		},
		disclaimers: undefined,
		download: {
			downloadDemoData: undefined,
			downloadEnabled: false,
			downloadRoles: undefined,
		},
		favoriteListsParams: undefined,
		footerPresets: undefined,
		footnotes: undefined,
		footnoteSingle: undefined,
		layoutSwitcher: undefined,
		namespace: "",
		notDeletable: undefined,
		pagingEnabled: true,
		resultTableConfig: {
			columns,
			resultRenderConfig,
			resultsDisplay,
		},
		searches: {
			searchAlertEnabled: false,
			searchesEnabled: true,
			viewBindingEnabled: true,
		},
		searchTitle: "",
		showResultsOnInitialPageLoad: false,
		supportLink: undefined,
		tabSearch: null,
		views: {
			viewsEnabled: true,
			visibilitySelector: undefined,
		},
	};
}
